export function truncateLongEmail(email: string, limit: number) {
  if (!email) {
    return '';
  }

  const splitEmail = email.split('@');
  const domain = splitEmail[1] || '';
  const emailUsername = splitEmail[0] || '';

  // Truncate only if username part exceeds the max length
  if (emailUsername.length <= limit) {
    return email;
  }

  // Truncate username part and keep full domain
  return `${emailUsername.slice(0, limit)}…@${domain}`;
}
